import { Injectable } from '@angular/core';
import { EquipmentListSubcategory } from '../used-equipments/models/equipmentList.model';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CompareService {
  private cartProducts: EquipmentListSubcategory[] = [];
  private _products: BehaviorSubject<any[]> = new BehaviorSubject<EquipmentListSubcategory[]>([]);

  constructor() {
    this.getRecovery();
  }

  setRecovery(): void {
    if (typeof Storage !== 'undefined') {
      const tmp: any = sessionStorage.getItem('rentalBckp');
      if (tmp !== null || tmp !== '') {
        if (this.cartProducts.length > 0) {
          sessionStorage.setItem('rentalBckp', JSON.stringify(this.cartProducts));
        } else {
          sessionStorage.removeItem('rentalBckp');
        }
      }
    }
  }

  getRecovery(): void {
    if (typeof Storage !== 'undefined') {
      const tmp: any = sessionStorage.getItem('rentalBckp');
      if (tmp !== null && tmp !== '') {
        this.cartProducts = JSON.parse(tmp);
        this._products.next(this.cartProducts);
      }
    }
  }

  get products() {
    return this._products.asObservable();
  }

  // add cart item
  addProduct(product: EquipmentListSubcategory): void {
    this.getRecovery();
    if (this.cartProducts.length === 4) return;
    const foundItem = this.cartProducts.find(
      (option) => option.economicNumber === product.economicNumber,
    );
    /* if (foundItem) {
      const index = this.cartProducts
        .map((filter) => filter.economicNumber)
        .indexOf(foundItem.economicNumber);
      this.cartProducts[index].count = this.cartProducts[index].count! + 1;
    } else {
      product.count = 1;
      this.cartProducts.push(product);
    } */
    if (!foundItem) {
      this.cartProducts.push(product);
    }
    this._products.next(this.cartProducts);
    this.setRecovery();
  }

  // remove cart item
  deleteProduct(economicNumber: string): void {
    this.getRecovery();
    const foundItem = this.cartProducts.find(
      (option) => option.economicNumber === economicNumber,
    );
    if (foundItem) {
      const index = this.cartProducts
        .map((filter) => filter.economicNumber)
        .indexOf(foundItem.economicNumber);
        this.cartProducts.splice(index, 1);
    }
    this._products.next(this.cartProducts);
    this.setRecovery();
  }

  // update cart item quantity
  /* updateQuantity(index: any, newCount: any) {
    this.getRecovery();
    this.cartProducts[index].count = newCount;
    this._products.next(this.cartProducts);
    this.setRecovery();
  } */

  // remove all items from the cart
  emptyCart(): void {
    this.getRecovery();
    this.cartProducts = [];
    this._products.next(this.cartProducts);
    this.setRecovery();
  }
}
